import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnRO: CultureInfo = {
  name: 'en-RO',
  displayName: 'English (Romania)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-RO',
  parent: CultureInfoEn
};
